import React, { useState } from 'react';
import { 
  FaFileContract, 
  FaShieldAlt, 
  FaCheckCircle,
  FaBook,
  FaGavel,
  FaHandshake,
  FaCreditCard,
  FaClock,
  FaUserShield,
  FaFileInvoice,
  FaExclamationTriangle
} from 'react-icons/fa';
import Footer from '../components/Footer';
import Header from '../components/Header';

const ConditionsVente = () => {
  const [activeSection, setActiveSection] = useState(null);

  const sections = [
    {
      id: 1,
      icon: FaBook,
      title: "1. Champ d'application",
      content: `CINEF est un organisme de formation professionnelle dont le siège social est établi à Ilot 1398 Ste Rita – Immeuble BOCOVE. CINEF propose et dispense des formations en présentiel inter et intra entreprise, des formations ouvertes et à distance en mode E-learning ainsi que des formations blended associant à la fois le présentiel et le E-learning. CINEF réalise également des études et du conseil opérationnel aux entreprises (l'ensemble des prestations CINEF étant ci-après dénommée "l'Offre de services CINEF" ou "l'Offre de services").

Les présentes conditions générales de vente (ci-après les "CGV") s'appliquent à toutes les Offres de services CINEF relatives à des commandes passées auprès de CINEF par tout client professionnel (ci-après "le Client"). Le fait de passer commande implique l'adhésion entière et sans réserve du Client aux présentes CGV.`
    },
    {
      id: 2,
      icon: FaHandshake,
      title: "2. Acceptation des conditions",
      content: `Toute condition contraire et notamment toute condition générale ou particulière opposée par le Client ne peut, sauf acceptation formelle et écrite de CINEF, prévaloir sur les présentes CGV et ce, quel que soit le moment où elle aura pu être portée à sa connaissance.

Le fait que CINEF ne se prévale pas à un moment donné de l'une quelconque des présentes CGV ne peut être interprété comme valant renonciation à s'en prévaloir ultérieurement.

Le Client se porte fort du respect des présentes CGV par l'ensemble de ses salariés, préposés et agents. Le Client reconnaît également que, préalablement à toute commande, il a bénéficié des informations et conseils suffisants de la part de CINEF, lui permettant de s'assurer de l'adéquation de l'Offre de services à ses besoins.`
    },
    {
      id: 3,
      icon: FaFileInvoice,
      title: "3. Prestations d'étude et de conseil",
      content: `Toute prestation d'étude et de conseil en gestion fait l'objet d'une proposition commerciale et financière établie par CINEF.

Cette proposition détaille les objectifs, le périmètre d'intervention, les livrables attendus, le calendrier prévisionnel ainsi que les conditions financières applicables. La prestation ne pourra débuter qu'après acceptation formelle de cette proposition par le Client.`
    },
    {
      id: 4,
      icon: FaCreditCard,
      title: "4. Modalités de paiement",
      content: `Les conditions de règlement sont précisées dans chaque proposition commerciale. Sauf disposition contraire mentionnée sur la facture, le paiement doit intervenir dans les délais légaux applicables aux transactions entre professionnels.

Tout retard de paiement entraînera de plein droit l'application de pénalités de retard calculées sur la base du taux d'intérêt appliqué par la Banque Centrale, majoré de 10 points de pourcentage. Ces pénalités sont exigibles sans qu'un rappel soit nécessaire.

En outre, conformément à la réglementation en vigueur, tout professionnel en situation de retard de paiement est de plein droit débiteur, à l'égard du créancier, d'une indemnité forfaitaire pour frais de recouvrement de 40 euros.`
    },
    {
      id: 5,
      icon: FaClock,
      title: "5. Formations E-learning",
      content: `Les clés d'accès à la plateforme E-learning sont strictement personnelles et incessibles. À ce titre, elles ne peuvent être cédées, revendues ni partagées. Le Client se porte garant auprès de CINEF de l'exécution de cette clause par tout Utilisateur et répondra de toute utilisation frauduleuse ou abusive des codes d'accès.

Le Client informera sans délai CINEF de la perte ou du vol des clés d'accès. En cas de violation de la clause d'inaliénabilité ou de partage constatés des clés d'accès, CINEF se réserve le droit de suspendre le service, sans indemnité, préavis, ni information préalable.

CINEF se réserve la faculté de modifier le(s) module(s) de formation proposé(s) sur sa plateforme E-LEARNING, tant dans leur organisation générale, que dans leur nature et leur contenu sans que cette modification ouvre droit à indemnité au profit du Client.`
    },
    {
      id: 6,
      icon: FaUserShield,
      title: "6. Confidentialité",
      content: `CINEF s'engage à respecter la confidentialité des informations communiquées par le Client dans le cadre de l'exécution des prestations. Cette obligation de confidentialité s'applique à l'ensemble des collaborateurs de CINEF amenés à intervenir sur le dossier.

Le Client accepte d'être cité par CINEF comme client de ses offres de services, aux frais de CINEF. Sous réserve du respect des dispositions relatives à la confidentialité, CINEF peut mentionner le nom du Client, son logo ainsi qu'une description objective de la nature des prestations, objet du contrat, dans ses listes de références et propositions à l'attention de ses prospects et de sa clientèle notamment sur son site internet.`
    },
    {
      id: 7,
      icon: FaGavel,
      title: "7. Droit applicable",
      content: `Les présentes conditions générales sont régies par le droit béninois.

En cas de litige relatif à l'interprétation ou à l'exécution des présentes conditions générales de vente, les parties s'efforceront de trouver une solution amiable. À défaut d'accord amiable dans un délai de 30 jours, le litige sera soumis aux juridictions compétentes du Bénin.`
    }
  ];

  return (
    <>
    <Header />
    <div className="cgv-wrapper">
      {/* Hero Section */}
      <section className="cgv-hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge">
              <FaShieldAlt className="badge-icon" />
              <span>Document Légal</span>
            </div>
            <h1 className="hero-title">
              Conditions Générales <br />
              <span className="gradient-text">de Vente</span>
            </h1>
            <p className="hero-description">
              Les présentes conditions générales définissent les droits et obligations de CINEF et de ses clients 
              dans le cadre de la fourniture de services de formation professionnelle.
            </p>
            <div className="hero-info">
              <div className="info-item">
                <FaCheckCircle />
                <span>Dernière mise à jour : Janvier 2026</span>
              </div>
              <div className="info-item">
                <FaFileContract />
                <span>Version 2.0</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="container">
          <div className="intro-card">
            <div className="intro-icon">
              <FaExclamationTriangle />
            </div>
            <div className="intro-content">
              <h3>Information importante</h3>
              <p>
                Veuillez lire attentivement ces conditions générales de vente avant de commander nos services. 
                En passant commande, vous acceptez d'être lié par les présentes conditions. Si vous n'acceptez 
                pas ces conditions, veuillez ne pas utiliser nos services.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CGV Sections */}
      <section className="cgv-content">
        <div className="container">
          <div className="sections-grid">
            {sections.map((section) => {
              const Icon = section.icon;
              const isActive = activeSection === section.id;
              
              return (
                <div 
                  key={section.id} 
                  className={`section-card ${isActive ? 'active' : ''}`}
                  onClick={() => setActiveSection(isActive ? null : section.id)}
                >
                  <div className="section-header">
                    <div className="section-icon">
                      <Icon />
                    </div>
                    <h3>{section.title}</h3>
                  </div>
                  
                  {isActive && (
                    <div className="section-content">
                      {section.content.split('\n\n').map((paragraph, idx) => (
                        <p key={idx}>{paragraph}</p>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      {/* <section className="contact-section">
        <div className="container">
          <div className="contact-card">
            <div className="contact-content">
              <h2>Des questions sur nos Conditions Générales de Ventes ?</h2>
              <p>
                Notre équipe est à votre disposition pour répondre à toutes vos questions 
                concernant nos conditions générales de vente.
              </p>
              <div className="contact-buttons">
                <button className="btn-primary">
                  Nous Contacter
                </button>
                <button className="btn-secondary">
                  Télécharger les CGV
                </button>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .cgv-wrapper {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          color: #1a202c;
          background: #ffffff;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 24px;
        }

        /* Hero Section */
        .cgv-hero {
          background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
          padding: 100px 0 80px;
          position: relative;
          overflow: hidden;
        }

        .cgv-hero::before {
          content: '';
          position: absolute;
          top: -20%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, rgba(253, 126, 20, 0.05) 0%, transparent 70%);
          border-radius: 50%;
        }

        .hero-content {
          text-align: center;
          position: relative;
          z-index: 1;
        }

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: white;
          padding: 10px 24px;
          border-radius: 50px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          margin-bottom: 24px;
          font-size: 14px;
          font-weight: 600;
          color: #fd7e14;
        }

        .badge-icon {
          animation: pulse 2s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }

        .hero-title {
          font-size: 52px;
          font-weight: 900;
          line-height: 1.15;
          color: #1a202c;
          margin-bottom: 20px;
          letter-spacing: -1.5px;
        }

        .gradient-text {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .hero-description {
          font-size: 18px;
          line-height: 1.7;
          color: #4a5568;
          max-width: 700px;
          margin: 0 auto 32px;
        }

        .hero-info {
          display: flex;
          gap: 32px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .info-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 15px;
          color: #718096;
          font-weight: 500;
        }

        .info-item svg {
          color: #198754;
          font-size: 18px;
        }

        /* Introduction Section */
        .intro-section {
          padding: 60px 0;
          background: white;
        }

        .intro-card {
          display: flex;
          gap: 24px;
          padding: 32px;
          background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);
          border-radius: 16px;
          border-left: 4px solid #fd7e14;
        }

        .intro-icon {
          width: 48px;
          height: 48px;
          background: white;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fd7e14;
          font-size: 24px;
          flex-shrink: 0;
        }

        .intro-content h3 {
          font-size: 20px;
          font-weight: 700;
          color: #1a202c;
          margin-bottom: 12px;
        }

        .intro-content p {
          font-size: 15px;
          line-height: 1.7;
          color: #4a5568;
        }

        /* CGV Content Section */
        .cgv-content {
          padding: 80px 0;
          background: #fafafa;
        }

        .sections-grid {
          display: grid;
          gap: 20px;
        }

        .section-card {
          background: white;
          border-radius: 16px;
          border: 2px solid #e2e8f0;
          overflow: hidden;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .section-card:hover {
          border-color: #fd7e14;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
        }

        .section-card.active {
          border-color: #fd7e14;
          box-shadow: 0 12px 32px rgba(253, 126, 20, 0.15);
        }

        .section-header {
          display: flex;
          align-items: center;
          gap: 20px;
          padding: 28px 32px;
        }

        .section-icon {
          width: 56px;
          height: 56px;
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 24px;
          flex-shrink: 0;
          transition: all 0.3s ease;
        }

        .section-card:hover .section-icon {
          transform: scale(1.05);
        }

        .section-header h3 {
          font-size: 18px;
          font-weight: 700;
          color: #1a202c;
          flex: 1;
        }

        .section-content {
          padding: 0 32px 28px 108px;
          animation: slideDown 0.3s ease;
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .section-content p {
          font-size: 15px;
          line-height: 1.8;
          color: #4a5568;
          margin-bottom: 16px;
        }

        .section-content p:last-child {
          margin-bottom: 0;
        }

        /* Contact Section */
        .contact-section {
          padding: 80px 0;
          background: linear-gradient(135deg, #858231 0%, #14942d 100%);
          position: relative;
          overflow: hidden;
        }

        .contact-section::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -20%;
          width: 600px;
          height: 600px;
          background: radial-gradient(circle, rgba(253, 126, 20, 0.1) 0%, transparent 70%);
          border-radius: 50%;
        }

        .contact-card {
          position: relative;
          z-index: 1;
        }

        .contact-content {
          text-align: center;
          color: white;
        }

        .contact-content h2 {
          font-size: 36px;
          font-weight: 900;
          margin-bottom: 16px;
        }

        .contact-content p {
          font-size: 18px;
          line-height: 1.7;
          opacity: 0.9;
          max-width: 600px;
          margin: 0 auto 32px;
        }

        .contact-buttons {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .btn-primary,
        .btn-secondary {
          padding: 16px 32px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          border: none;
          font-family: inherit;
        }

        .btn-primary {
          background: linear-gradient(135deg, #fd7e14 0%, #dc3545 100%);
          color: white;
          box-shadow: 0 8px 24px rgba(253, 126, 20, 0.35);
        }

        .btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 32px rgba(253, 126, 20, 0.45);
        }

        .btn-secondary {
          background: transparent;
          color: white;
          border: 2px solid white;
        }

        .btn-secondary:hover {
          background: white;
          color: #1a202c;
          transform: translateY(-2px);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .hero-title {
            font-size: 36px;
          }

          .hero-description {
            font-size: 16px;
          }

          .hero-info {
            flex-direction: column;
            gap: 16px;
          }

          .intro-card {
            flex-direction: column;
            padding: 24px;
          }

          .section-content {
            padding: 0 24px 24px 24px;
          }

          .section-header {
            padding: 20px 24px;
          }

          .contact-content h2 {
            font-size: 28px;
          }

          .contact-content p {
            font-size: 16px;
          }

          .contact-buttons {
            flex-direction: column;
            align-items: stretch;
          }

          .btn-primary,
          .btn-secondary {
            width: 100%;
          }
        }
      `}</style>
    </div>
    <Footer />
    </>
  );
};

export default ConditionsVente;